import React, { useContext, useEffect, useMemo, useState } from "react";
import "../styles/Cart.css";
import { FaTrash, FaPlus, FaMinus, FaShoppingCart } from "react-icons/fa";
import {
  DeleteFromCart,
  getProductQty,
  Purchaseorder,
} from "../services/Cart";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../contextApi/CartContext";
import { withImageVersion } from "../contextApi/ImageVersionContext";
import { showSnackbar } from "../comopnents/snackbar";
import { FaLock } from "react-icons/fa";
import { GiPartyPopper } from "react-icons/gi";
import { Alert } from "antd";
import noimage from "../assets/noimage.webp";
import {
  calculateCartPurchaseData,
  getPurchaseOptionByType,
  getApplicableCoupon,
  getNextQuantity,
  getPreviousQuantity,
  getQuantityStep,
  getSavedCartPurchaseData,
  recalculateCartItemDiscount,
  removeSavedCartPurchaseData,
  saveCartPurchaseData,
} from "../utils/purchaseOptions";

const Cart = () => {
  const { removeFromCart, setCartQty, items, replaceCartItem, fetchCart } = useContext(CartContext);
  const cartItems = useMemo(
    () => (items || []).map(recalculateCartItemDiscount),
    [items],
  );
  const [loadingitems, setLoadingitems] = useState(false);
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [userId, setuserId] = useState("");
  const [isapplying, setIsApplying] = useState(false);
  const [shippingCost, setShippingCost] = useState(0);
  const navigate = useNavigate();
  const [totals, setTotals] = useState({
    totalMRP: 0,
    totalDiscountAmount: 0,
    totalCost: 0,
    totalWeight: 0,
    totalGst: 0,
    totalGross: 0,
    totalSpecialDisc: 0,
    totalDlrDisc: 0,
  });

  const onClose = e => {
    console.log(e, 'I was closed.');
  };

  useEffect(() => {
    const id = localStorage.getItem("userId");
    setuserId(id);
  }, []);

  useEffect(() => {
    fetchCart();
  }, []);

  const handlePress = async (
    userId,
    productid,
    currentQty,
    stock,
    minqty,
    productData,
    fnc,
  ) => {
    const savedPurchaseData = getSavedCartPurchaseData(productid);
    const purchaseType = savedPurchaseData?.purchaseType || "piece";
    const purchaseSource = {
      ...productData,
      ...savedPurchaseData,
      productid,
      minorderqty: productData?.minorderqty || minqty,
    };
    const increment = getQuantityStep(purchaseSource) || Number(minqty) || 1;
    const minimumQty = increment;
    const newQty =
      fnc === "add"
        ? getNextQuantity(currentQty, purchaseSource)
        : Math.max(getPreviousQuantity(currentQty, purchaseSource), minimumQty);

    // Stock check
    if (newQty > stock) {
      alert("Limited Stock Available");
      return;
    }

    try {
      const response = await getProductQty({
        user_id: userId,
        productid,
        qty: newQty,
      });

      // API response may lack Qtydiscounts / discount / mrp needed for slab
      // recalculation. Merge with the current cart item to fill those gaps.
      const itemData = response.data[0];
      const currentCartItem = cartItems.find(
        (i) => i.dtl?.[0]?.productid === productid
      );

      if (itemData?.dtl?.[0] && currentCartItem?.dtl?.[0]) {
        const src = currentCartItem.dtl[0];
        const tgt = itemData.dtl[0];
        if (!tgt.Qtydiscounts?.length) tgt.Qtydiscounts = src.Qtydiscounts || [];
        if (!tgt.discount_items?.length) tgt.discount_items = src.discount_items || [];
        if (!tgt.discount && src.discount) tgt.discount = src.discount;
        if ((!tgt.mrp || Number(tgt.mrp) === 0) && src.mrp) tgt.mrp = src.mrp;
        itemData.qty = newQty;
      }

      const updatedItem = recalculateCartItemDiscount(itemData || {
        ...currentCartItem,
        qty: newQty,
      });
      const applicableCoupon = getApplicableCoupon(
        newQty,
        updatedItem?.Qtydiscounts || updatedItem?.dtl?.[0]?.Qtydiscounts || [],
      );
      setCartQty(productid, newQty);
      replaceCartItem(productid, updatedItem);
      saveCartPurchaseData({
        ...savedPurchaseData,
        ...calculateCartPurchaseData(
          { ...(updatedItem || { productid }), ...savedPurchaseData },
          purchaseType,
          newQty,
        ),
        Qtydiscounts: updatedItem?.dtl?.[0]?.Qtydiscounts || savedPurchaseData?.Qtydiscounts || [],
        discount_items: updatedItem?.dtl?.[0]?.discount_items || updatedItem?.discount_items || savedPurchaseData?.discount_items || [],
        productDiscount: Number(updatedItem?.dtl?.[0]?.discount || savedPurchaseData?.productDiscount || updatedItem?.disp || 0),
        mrp: Number(updatedItem?.dtl?.[0]?.mrp || 0) || (Number(updatedItem?.mrp || 0) / newQty),
        extraDiscount: Number(updatedItem?.spldis || 0),
        totalDiscount: Number(updatedItem?.disp || savedPurchaseData?.totalDiscount || 0),
        couponSelected: !!applicableCoupon,
        appliedCouponQty: applicableCoupon ? Number(applicableCoupon.fromqty) : null,
        minimumCouponQty: applicableCoupon ? Number(applicableCoupon.fromqty) : null,
        applicableCoupon,
      });

      console.log("Updated cart qty:", productid, newQty);
    } catch (error) {
      console.error("API Error:", error?.message || error);
    }
  };

  const handleDelete = async (userId, productid) => {
    try {
      console.log(typeof userId);
      console.log(productid);
      const response = await DeleteFromCart({
        customerid: userId,
        productid: productid,
      });
      console.log("API Response:", response);
      if (response.status === 200) {
        removeFromCart(productid);
        removeSavedCartPurchaseData(productid);
      }
    } catch (error) {
      console.error("API Error:", error?.message || error);
    }
  };

  useEffect(() => {
    if (!Array.isArray(cartItems) || cartItems.length === 0) {
      setTotals({
        totalMRP: 0,
        totalDiscountAmount: 0,
        totalCost: 0,
        totalWeight: 0,
        totalGst: 0,
        totalGross: 0,
        totalSpecialDisc: 0,
        totalDlrDisc: 0,
      });
      return;
    }

    const calculated = cartItems.reduce(
      (acc, item) => {
        const mrp = item.dtl[0]?.netrate ? Number(item.dtl[0]?.netrate * item.qty) : Number(item?.mrp || 0);
        const discount = item?.disp || 0;
        const spcl = item?.splamount || 0;
        const dlr = item?.dealerdisamt || 0;
        const gst = item?.gsta || 0;
        const qty = item?.qty || 1;
        const weight = item?.dtl?.[0]?.netw || 0;
        const netrate = Number(item.dtl?.[0]?.netrate * item.qty || 0);
        const gross = netrate > 0 ? netrate : Number(item?.gross || 0);

        const totalMRP = mrp;
        const discountAmt = ((mrp * discount) / 100);
        const costAfterDisc = totalMRP - discountAmt;
        const totalWeight = weight * qty;

        acc.totalMRP += totalMRP;
        acc.totalDiscountAmount += discountAmt;
        acc.totalCost += costAfterDisc;
        acc.totalGst += gst;
        acc.totalWeight += totalWeight;
        acc.totalSpecialDisc += spcl;
        acc.totalDlrDisc += dlr * qty;
        acc.totalGross += gross;

        return acc;
      },
      {
        totalMRP: 0,
        totalDiscountAmount: 0,
        totalCost: 0,
        totalWeight: 0,
        totalGst: 0,
        totalSpecialDisc: 0,
        totalDlrDisc: 0,
        totalGross: 0,
      },
    );

    setTotals(calculated);
  }, [cartItems]);

  const calculateSubtotal = () => {
    return cartItems.reduce((total, item) => {
      return total + Number(item.afterspldis || 0);
    }, 0);
  };

  const calculateShipping = () => {
    const subtotal = calculateSubtotal();
    return subtotal >= 500 ? 0 : 50;
  };

  const calculateTax = () => {
    return calculateSubtotal() * 0.18;
  };

  const calculateTotal = () => {
    return calculateSubtotal() + calculateShipping() + calculateTax();
  };

  const handleCheckout = () => {
    showSnackbar(
      `Order placed successfully! Total: ₹${calculateTotal().toFixed(2)}`,
    );
  };

  const continueShopping = () => {
    window.location.href = "/categories";
  };

  const getDiscountedPrice = (mrp, discount) => {
    return mrp - (mrp * discount) / 100;
  };

  return (
    <div className="cart-page">
      <div className="cart-container">
        <h2 className="cart-title">Your Shopping Cart</h2>

        {cartItems.length === 0 ? (
          <div className="empty-cart">
            <FaShoppingCart className="empty-cart-icon" />
            <h3>Your cart is empty</h3>
            <p>Add some products to your cart to see them here.</p>
            <button
              className="continue-shopping-btn"
              onClick={continueShopping}
            >
              Continue Shopping
            </button>
          </div>
        ) : (
          <>
            <div className="cart-content">
              <div className="cart-items-section">
                <div className="cart-header">
                  <h3>Cart Items ({cartItems.length})</h3>
                </div>

                <div className="cart-items-list">
                  {cartItems?.map((item) => {
                    const productId = item.dtl[0]?.productid;
                    const savedPurchaseData = getSavedCartPurchaseData(productId);
                    const purchaseData = calculateCartPurchaseData(
                      { ...item, ...savedPurchaseData },
                      savedPurchaseData?.purchaseType || "piece",
                      item.qty,
                    );
                    const purchaseOption = getPurchaseOptionByType(
                      purchaseData.purchaseType,
                    );

                    return (
                      <div key={productId}>
                        <div className="cart-item">
                          <div className="item-image">
                            <img
                              src={withImageVersion(item.dtl[0]?.image1?.trim()) || noimage}
                              alt={item.name}
                              onError={(e) => (e.target.src = noimage)}
                              onClick={() =>
                                navigate(
                                  `/productdetail?productid=${item.dtl[0]?.productid}`,
                                )
                              }
                            />
                          </div>

                          <div className="cart-item-divider" />

                          <div className="item-details">
                            <div className="item-details-top">
                              <span className="item-sku">
                                {(item.dtl[0]?.displaymodelno || '').toUpperCase()}
                              </span>
                              <h4 className="item-name">
                                {item.dtl[0]?.subcategory}
                              </h4>
                              <p className="item-category">{item.dtl[0]?.category}</p>

                              <div className="price-container">
                                {Number(item.dtl?.[0]?.netrate) > 0 ? (
                                  <span className="current-price">₹{Number(item.dtl?.[0]?.netrate || 0).toFixed(2)}</span>
                                ) : (
                                  <>
                                    <span className="current-price">
                                      ₹{(Number(item.gross) / item.qty).toFixed(2)}
                                    </span>
                                    <span className="mrp-price">
                                      ₹{(Number(item.mrp) / item.qty).toFixed(2)}
                                    </span>
                                    
                                    {(Number(item.dtl?.[0]?.discount) > 0 ||
                                      Number(item.spldis) > 0 ||
                                      Number(item.dealerdis) > 0) && (
                                        <>
                                          {(Number(item.dtl?.[0]?.discount) > 0 ||
                                            Number(item.spldis) > 0) && (
                                              <span className="discount-price">
                                                {Number(item.dtl?.[0]?.discount || 0)}%
                                                {Number(item.spldis) > 0 && ` + ${Number(item.spldis)}%`}
                                                {" OFF"}
                                              </span>
                                            )}

                                          {Number(item.dealerdis) > 0 && (
                                            <span className="discount-price">
                                              {Number(item.dealerdis)}% OFF
                                            </span>
                                          )}
                                        </>
                                      )}
                                   

                                  </>
                                )}
                              </div>
                              {item.dtl[0]?.stock < item.qty && (
                                <h6 style={{ color: "#e53935", margin: "4px 0 0 0" }}>Out Of Stock</h6>
                              )}
                            </div>

                            <div className="item-details-bottom">
                              <button
                                className="remove-item-btn"
                                onClick={() =>
                                  handleDelete(userId, productId)
                                }
                              >
                                <FaTrash />
                                Delete
                              </button>
                              <div className="item-quantity">
                                <button
                                  className="quantity-btn"
                                  onClick={() =>
                                    handlePress(
                                      userId,
                                      productId,
                                      Number(item.qty),
                                      item.dtl[0]?.stock,
                                      item.dtl[0]?.minorderqty,
                                      item.dtl[0],
                                      "minus",
                                    )
                                  }
                                  disabled={
                                    item.qty <= getQuantityStep(item.dtl?.[0] || item)
                                  }
                                >
                                  <FaMinus />
                                </button>
                                <span className="quantity-value">{item.qty}</span>
                                <button
                                  className="quantity-btn"
                                  onClick={() =>
                                    handlePress(
                                      userId,
                                      productId,
                                      Number(item.qty),
                                      item.dtl[0]?.stock,
                                      item.dtl[0]?.minorderqty,
                                      item.dtl[0],
                                      "add",
                                    )
                                  }
                                >
                                  <FaPlus />
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="cart-item-divider" />

                          <div className="price-summary">
                            {/* <div className="price-summary-row">
                              <span className="price-summary-label">Purchase Type</span>
                              <span className="price-summary-value">
                                {savedPurchaseData?.couponSelected ? (
                                  savedPurchaseData.purchaseType === "piece" ? "Piece" :
                                    savedPurchaseData.purchaseType === "pack" ? "Pack" :
                                      savedPurchaseData.purchaseType === "carton" ? "Carton" : ""
                                ) : (
                                  purchaseOption.displayType
                                )}
                              </span>
                            </div> */}
                            {/* {savedPurchaseData?.couponSelected && (
                              <div className="price-summary-row">
                                <span className="price-summary-label">Coupon</span>
                                <span className="price-summary-value">{savedPurchaseData.couponTitle}</span>
                              </div>
                             )} */}
                            <div className="price-summary-row">
                              <span className="price-summary-label">MRP</span>
                              <span className="price-summary-value">₹{Number((item.mrp ?? 0)).toFixed(2)}</span>
                            </div>
                            <div className="price-summary-row">
                              <span className="price-summary-label">Net Rate</span>
                              <span className="price-summary-value">₹{item?.dtl[0]?.netrate ? Number(item?.dtl[0]?.netrate * item.qty).toFixed(2) : Number((item.mrp ?? 0)).toFixed(2)}</span>
                            </div>
                            <div className="price-summary-row">
                              <span className="price-summary-label">Discount ({Number(item.dtl?.[0]?.discount || item.dis || 0)}%)</span>
                              <span className="price-summary-value">₹{Number((item.disamount ?? item.disa ?? 0)).toFixed(2)}</span>
                            </div>
                            {item?.dealerdisamt != null && Number(item.dealerdisamt) > 0 && (
                              <div className="price-summary-row">
                                <span className="price-summary-label">Dealer Disc ({item.dealerdis}%)</span>
                                <span className="price-summary-value">₹{Number((item.dealerdisamt).toFixed(2))}</span>
                              </div>
                            )}
                            {Number(item.splamount) != 0 && (
                              <div className="price-summary-row">
                                <span className="price-summary-label">Special Disc ({item.spldis}%)</span>
                                <span className="price-summary-value">₹{Number((item.splamount ?? 0)).toFixed(2)}</span>
                              </div>
                            )}
                            <div className="price-summary-row">
                              <span className="price-summary-label">GST ({item.gstp}%)</span>
                              <span className="price-summary-value">₹{((item.gsta ?? 0)).toFixed(2)}</span>
                            </div>
                            <div className="price-summary-divider" />
                            <div className="price-summary-total">
                              <span className="price-summary-label">Total</span>
                              <span className="price-summary-value">
                                ₹{Number(item.dtl?.[0]?.netrate) > 0
                                  ? Number(item.dtl?.[0]?.netrate * item.qty).toFixed(2)
                                  : Number(item?.gross).toFixed(2)
                                }
                              </span>
                            </div>
                          </div>
                        </div>
                        {item?.dtl?.[0]?.free_items?.[0]?.minqty <= item.qty && (
                          <div className="free-items-section">
                            <h5 className="free-items-title">Free Items</h5>
                            {item?.dtl[0]?.free_items?.map((items, index) => (
                              <div key={index} className="free-item-card">
                                <img
                                  onClick={() => navigate(`/productdetail?productid=${items.feeproductid}`)}
                                  src={withImageVersion(items.image)}
                                  alt={items.product_name}
                                  className="free-item-image"
                                />
                                <div className="free-item-info">
                                  <h6 className="free-item-name">{items.product_name}</h6>
                                  <p className="free-item-category">{items.category}</p>
                                  <p className="free-item-mrp">MRP: ₹{Number(items.price || 0).toFixed(2)}</p>
                                </div>
                                <span className="free-item-badge">FREE</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>

                <div className="continue-shopping">
                  <button
                    className="continue-shopping-btn"
                    onClick={continueShopping}
                  >
                    ← Continue Shopping
                  </button>
                </div>
              </div>

              <div className="order-summary">
                <h3>Order Summary</h3>

                <div className="summary-details">
                  <div className="summary-row">
                    <span>MRP Total</span>
                    <span>₹{totals.totalMRP.toFixed(2)}</span>
                  </div>

                  <div className="summary-row">
                    <span>Total Discount</span>
                    <span className="summary-row">
                      ₹{(totals.totalMRP - totals.totalGross).toFixed(2)}
                    </span>
                  </div>
                  {totals.totalDlrDisc != 0 && (
                    <div className="summary-row">
                      <span>Dealar Discount</span>
                      <span className={"summary-row"}>
                        ₹{(totals.totalDlrDisc).toFixed(2)}
                      </span>
                    </div>
                  )}
                  <div className="summary-row">
                    <span>Tax (GST)</span>
                    <span>₹{totals.totalGst.toFixed(2)}</span>
                  </div>

                  <div className="summary-row">
                    <span>Total(including GST)</span>₹
                    {totals.totalGross.toFixed(2)}
                  </div>
                  <div className="summary-divider"></div>

                  <div className="summary-row total">
                    <span>Final Total</span>
                    <span className="total-amount">
                      ₹{totals.totalGross.toFixed(2)}
                    </span>
                  </div>

                  {/* <div className="shipping-note">
                    {totals.totalGross < 1000 ? (
                      <p>
                        Add ₹{(1000 - totals.totalGross).toFixed(2)} more to get
                        FREE shipping!
                      </p>
                    ) : (
                      <p className="free-shipping">
                        <GiPartyPopper color="#005487" /> You qualify for FREE shipping!
                      </p>
                    )}
                  </div> */}
                </div>

                <button
                  className="checkout-btn"
                  onClick={() => navigate("/Checkout")}
                >
                  Proceed to Checkout
                </button>

                <div className="security-note">
                  <p><FaLock color="#005487" /> Your payment information is secure and encrypted.</p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Cart;
